import { render, staticRenderFns } from "./PayMOrder.vue?vue&type=template&id=f2986b6c"
import script from "./PayMOrder.vue?vue&type=script&lang=js"
export * from "./PayMOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports